import React from 'react';
import _ from 'lodash';
import DatePicker from 'react-datepicker';

import InputCurrencyField from '../../Fields/InputCurrencyField';
import InputSelectField from '../../Fields/InputSelectField';
import InputTextField from '../../Fields/InputTextField';
import CreditEntryTable from './CreditEntryTable';

import { formatDateForDisplay } from '../../../Utils/date';

import './CreditLineItemPanel.scss';
import featureFlags from '../../../featureFlags';

class CreditLineItemPanel extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            displayCreditEntries: props.newMode,
        }
    }

    componentDidUpdate(prevProps) {
        const applicationType = this.props.credit.fields.application_type.value;
        if (prevProps.credit.fields.application_type.value !== applicationType && applicationType === 'DO_NOT_APPLY_CASH') {
            const entry = _.cloneDeep(this.props.credit.fields.credit_entries.value[0]);
            entry.fields = {
                ...entry.fields,
                amount: { value: null },
                amount_tax_1: { value: null },
                amount_tax_2: { value: null },
                amount_tax_3: { value: null },
                amount_tax_4: { value: null },
            };
            this._onCreditEntryChange(0, entry);
        }
    }

    _onCreditEntryChange = (ident, value) => {
        const entries = _.cloneDeep(this.props.credit.fields.credit_entries.value);
        if (ident === null) {
            entries.push(value);
        } else if (value === null) {
            entries.splice(ident, 1);
        } else {
            entries[ident] = value;
        }

        this.props.onChange('credit_entries')(entries);
    }

    _onValueChange = key => value => {
        if (key === 'application_type') {
            switch (value) {
                case 'DO_NOT_APPLY_CASH':
                    this.props.onChange('applicationDate')(null);
                    break;
                case null:
                    this.props.onChange('applicationDate')(new Date());
                    break;
                default:
            }
        }

        this.props.onChange(key)(value);
    };

    handleToggleLineItemEntriesClick = () => {
        this.setState({ displayCreditEntries: !this.state.displayCreditEntries });
    }

    _onPaymentMetaChange = (value) => {
        const payment_meta = _.cloneDeep(this.props.credit.fields.payment_meta.value);
        payment_meta.check_number = value;

        this.props.onChange('payment_meta')(payment_meta)
    }

    getEntryRows = () => {
        return this.props.credit.fields.credit_entries.value.map((entry, index) => {
            return { ident: index, data: entry };
        });
    };

    render() {
        const {
            credit,
            applicationDate: applicationDateRaw,
            newMode,
            fieldConfiguration,
        } = this.props;

        let paymentTypeOptions = fieldConfiguration.payment_type.options;

        // only show the carryover credit payment type option
        // if the feature flag is enabled
        if (!featureFlags.CARRYOVER_CREDIT) {
            paymentTypeOptions = paymentTypeOptions.filter(
                ({ value }) => value !== 'Carryover Credit'
            );
        }

        // only show the discount credit payment type option
        // if the feature flag is enabled
        if (!featureFlags.DISCOUNT_CREDIT) {
            paymentTypeOptions = paymentTypeOptions.filter(
                ({ value }) => value !== 'Discount Credit'
            );
        }

        const { displayCreditEntries } = this.state;

        const { application_type: { value: applicationType } } = credit.fields;
        const { payment_type: { value: paymentType } } = credit.fields;

        const showApplicationType = paymentType !== 'Carryover Credit' && paymentType !== 'Discount Credit';
        const isApplyCash = applicationType === 'APPLY_CASH';

        const applicationDate = applicationDateRaw ? applicationDateRaw : isApplyCash ? new Date() : null;
        const applicationDateFormatted = applicationDate ? formatDateForDisplay(applicationDate) : null;

        const amount = credit.fields.amount.value;
        const balance = credit.fields.balance.value;
        const entryRows = this.getEntryRows();
        return (
            <div className="parkchirp--credit-line-item-panel">
                <header className="parkchirp--credit-panel--header">
                    {featureFlags.OVERPAYMENT_PT2_C &&
                        <>
                            <div className={`parkchirp--credit-panel--payment-type-column parkchirp--credit-panel--cell overpayment`}>
                                <span className="parkchirp--credit-panel--column-heading">Payment Type</span>
                            </div>
                            <div className={`parkchirp--credit-panel--payment-id-column parkchirp--credit-panel--cell overpayment`}>
                                <span className="parkchirp--credit-panel--column-heading">Payment ID</span>
                            </div>
                            {
                                showApplicationType &&
                                <div className={`parkchirp--credit-panel--payment-type-column parkchirp--credit-panel--cell overpayment`}>
                                    <span className="parkchirp--credit-panel--column-heading">Application Type</span>
                                </div>
                            }
                        </>
                    }
                    {(!featureFlags.CREDIT_UPDATES || newMode) && showApplicationType &&
                        <div className={`parkchirp--credit-panel--app-date-column parkchirp--credit-panel--cell`}>
                            <span className="parkchirp--credit-panel--column-heading">Credit Application Date</span>
                        </div>
                    }
                    <div className={`parkchirp--credit-panel--amount-column parkchirp--credit-panel--cell`}>
                        <span className="parkchirp--credit-panel--column-heading">Amount</span>
                    </div>
                    <div className={`parkchirp--credit-panel--balance-column parkchirp--credit-panel--cell`}>
                        <span className="parkchirp--credit-panel--column-heading">Balance</span>
                    </div>
                    <div className="parkchirp--credit-panel--actions-column parkchirp--credit-panel--cell">
                    </div>
                </header>
                <div className="parkchirp--credit-panel--body">
                    <div className="parkchirp--credit-panel-row">
                        <div className="parkchirp--credit-panel-row--line-item-container">
                            {featureFlags.OVERPAYMENT_PT2_C &&
                                <>
                                    <div className={`parkchirp--credit-panel--payment-type-column parkchirp--credit-panel--cell overpayment`}>
                                        <InputSelectField inputId="parkchirp--credit--payment-type"
                                            options={paymentTypeOptions}
                                            value={credit.fields.payment_type.value}
                                            editMode={featureFlags.OVERPAYMENT_PT2_C ? newMode : false}
                                            onChange={this._onValueChange('payment_type')}
                                        />
                                    </div>
                                    <div className={`parkchirp--credit-panel--payment-id-column parkchirp--credit-panel--cell overpayment`}>
                                        <InputTextField inputId="parkchirp--credit-panel--payment-id"
                                            value={credit.fields.payment_meta.value?.check_number || ''}
                                            editMode={newMode}
                                            onChange={this._onPaymentMetaChange}
                                        />
                                    </div>
                                    {showApplicationType &&
                                        <div className="parkchirp--credit-panel--app-type-column parkchirp--credit-panel--cell overpayment">
                                            <InputSelectField inputId="parkchirp--credit--application-type"
                                                options={fieldConfiguration.application_type.options}
                                                value={applicationType}
                                                editMode={newMode}
                                                onChange={this._onValueChange("application_type")}
                                                disabledMode={true}
                                            />
                                        </div>
                                    }
                                </>
                            }
                            {(!featureFlags.CREDIT_UPDATES || newMode) && showApplicationType &&
                                <div className="parkchirp--credit-panel--app-date-column parkchirp--credit-panel--cell">
                                    {isApplyCash && newMode ?
                                        <DatePicker
                                            inputId="parkchirp--credit-panel--app-date"
                                            key={`application-date`}
                                            selected={applicationDate}
                                            onChange={this._onValueChange('applicationDate')}
                                            disabled={false}
                                            excludeDates={fieldConfiguration.dateConfig.exclude}
                                            minDate={fieldConfiguration.dateConfig.minDate}
                                            maxDate={fieldConfiguration.dateConfig.maxDate}
                                        />
                                        :
                                        <InputTextField
                                            disabledMode={true}
                                            inputId={`parkchirp--credit-panel--app-date`}
                                            value={applicationDateFormatted ?? "-"}
                                            editMode={false}
                                        />
                                    }
                                </div>
                            }
                            <div className="parkchirp--credit-panel--amount-column parkchirp--credit-panel--cell">
                                <InputCurrencyField
                                    inputId="parkchirp--credit-panel-amount"
                                    key={`credit--amount`}
                                    value={amount}
                                    editMode={false}
                                />
                            </div>
                            <div className="parkchirp--credit-panel--balance-column parkchirp--credit-panel--cell">
                                <InputCurrencyField inputId="parkchirp--credit-panel-balance"
                                    key={`credit--balance`}
                                    value={balance}
                                    editMode={false}
                                />
                            </div>
                            <div className="parkchirp--credit-panel--actions-column parkchirp--credit-panel--cell">
                                {!newMode &&
                                    <button type="button" onClick={this.handleToggleLineItemEntriesClick}>...</button>
                                }
                            </div>
                        </div>
                        {(displayCreditEntries) && (
                            <div className="parkchirp--credit-panel-row--entry-container">
                                <CreditEntryTable inputId={'parkchirp--credit-panel--entries'}
                                    entryRows={entryRows}
                                    newMode={newMode}
                                    credit={credit}
                                    onCreditEntryChange={this._onCreditEntryChange}
                                    fieldConfiguration={fieldConfiguration}
                                    applicationType={applicationType}
                                />
                            </div>
                        )}
                    </div>
                </div>
            </div>
        )
    }
}

export default CreditLineItemPanel;
